module.exports = __webpack_public_path__ + "img/ar1.c9ec81aa.jpg";